/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IRangeExSchema } from '../../entities/range/RangeExSchema';
import { IGeoExV4Schema } from '../../entities/geo/GeoExV4Schema';
import { IPriceRangeExSchema } from '../../entities/price_range/PriceRangeExSchema';

export type TCreateMessageModel = IModel<ICreateMessageRequest, TCreateMessageResponse>;

export interface ICreateMessageRequest {
  /** Площадь **/
  area?: IRangeExSchema | null;
  /** Комментарий **/
  comment?: string | null;
  /** Требуемая срочность завершения сделки **/
  dealPeriod: EDealPeriod;
  /** Тип сделки **/
  dealTypeEx: EDealTypeEx;
  /** E-mail **/
  email?: string | null;
  /** Первичная/вторичная недвижимость **/
  firstOrSecond?: EFirstOrSecond | null;
  /** ФИО **/
  fullName: string;
  /** Геоданные **/
  geo: IGeoExV4Schema;
  /** Объект в залоге у банка **/
  isBankDeposit: boolean;
  /** В кредит **/
  isCredit?: boolean | null;
  /** Объявление уже размещено? **/
  isHasOffer: boolean;
  /** Вы получили объект в наследство? **/
  isInheritance?: boolean | null;
  /** В числе собственников есть несовершеннолетние? **/
  isMinorOwners?: boolean | null;
  /** Уже накоплен первоначальный взнос? **/
  isMortgageInitialPayment: boolean;
  /** Уже выбрали проект дома под строительство? **/
  isProjectExists?: boolean | null;
  /** Готовность снизить цену, в случае необходимости **/
  isReadyToLower: boolean;
  /** Тестовая заявка **/
  isTest?: boolean | null;
  /** Наличие одобрения ипотеки от банка **/
  mortgageBankApprove: EMortgageBankApprove;
  /** Рассматриваете вариант покупки участка и постройки {дома}? **/
  needLandForBuilding?: boolean | null;
  /** Хотите подобрать проект дома и рассчитать его примерную стоимость? **/
  needProject?: boolean | null;
  /** Тип объекта **/
  objectType: EObjectType;
  /** Требуемый тип недвижимости **/
  offerType: EOfferType;
  /** Телефон **/
  phone: string;
  /** Цена **/
  price?: IPriceRangeExSchema | null;
  /** Как планируете покупать квартиру? **/
  purchaseMethod?: EPurchaseMethod | null;
  /** Тип аренды **/
  rentType?: ERentType | null;
  /** Количество комнат **/
  roomCount?: ERoomCount[] | null;
  /** Источник заявки **/
  source?: string | null;
}

export type TCreateMessageResponse = ICreateMessageResponse200 | ICreateMessageResponse400;

export interface ICreateMessageResponse200 extends IModelResponse<ICreateMessageResponse> {
  statusCode: 200;
}

export interface ICreateMessageResponse400 extends IModelResponse<ICreateMessageResponseError> {
  statusCode: 400;
}

export interface ICreateMessageResponse {
  /** Время до следующей отправки кода подтверждения **/
  confirmTimeout?: number | null;
  /** ID заявки **/
  id: number;
  /** Статус ответа **/
  status: EStatus;
}

export interface ICreateMessageResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ICreateMessageResponse | ICreateMessageResponseError;

export enum EStatus {
  /** Не правильный код подтверждения **/
  CodeError = 'codeError',
  /** Дубликат **/
  Duplicate = 'duplicate',
  /** Необходимо подтверждение номера телефона **/
  NeedPhoneConfirm = 'needPhoneConfirm',
  /** Успешно **/
  Ok = 'ok',
}

export enum EDealPeriod {
  /** Больше месяца **/
  MoreMonth = 'moreMonth',
  /** В течение месяца **/
  OneMonth = 'oneMonth',
  /** В течение недели **/
  OneWeek = 'oneWeek',
  /** В течение 7 дней **/
  SevenDays = 'sevenDays',
  /** В течение 6 месяцев **/
  SixMonths = 'sixMonths',
  /** В течение 3 месяцев **/
  ThreeMonths = 'threeMonths',
  /** В течение 12 месяцев **/
  TwelveMonths = 'twelveMonths',
  /** В течение 2-3 недель **/
  TwoThreeWeeks = 'twoThreeWeeks',
  /** В течение 2 недель **/
  TwoWeek = 'twoWeek',
}

export enum EDealTypeEx {
  /** Покупаю **/
  Buy = 'buy',
  /** Сдаю **/
  Rent = 'rent',
  /** Продаю **/
  Sale = 'sale',
  /** Продаю, чтобы купить **/
  SellToBuy = 'sellToBuy',
  /** Арендую **/
  Tenant = 'tenant',
}

export enum EFirstOrSecond {
  /** Неважно **/
  DoesNotMatter = 'doesNotMatter',
  /** Новостройка **/
  First = 'first',
  /** Вторичка **/
  Second = 'second',
}

export enum EMortgageBankApprove {
  /** В процессе **/
  InProcess = 'inProcess',
  /** Нет **/
  No = 'no',
  /** Да **/
  Yes = 'yes',
}

export enum EObjectType {
  /** Койко место **/
  Bed = 'bed',
  /** Здание **/
  Building = 'building',
  /** Готовый бизнес **/
  Business = 'business',
  /** Автосервис **/
  CarService = 'carService',
  /** Коммерческая земля **/
  CommercialLand = 'commercialLand',
  /** Коттедж **/
  Cottage = 'cottage',
  /** Бытовые услуги **/
  DomesticServices = 'domesticServices',
  /** Квартира **/
  Flat = 'flat',
  /** Доля в квартире **/
  FlatShare = 'flatShare',
  /** Помещение свободного назначения **/
  FreeAppointmentObject = 'freeAppointmentObject',
  /** Гараж **/
  Garage = 'garage',
  /** Дом **/
  House = 'house',
  /** Часть дома **/
  HouseShare = 'houseShare',
  /** Производство **/
  Industry = 'industry',
  /** Участок **/
  Land = 'land',
  /** Продажа квартиры в новостройке **/
  NewBuildingFlat = 'newBuildingFlat',
  /** Офис **/
  Office = 'office',
  /** Общепит **/
  PublicCatering = 'publicCatering',
  /** Комната **/
  Room = 'room',
  /** Торговая площадь **/
  ShoppingArea = 'shoppingArea',
  /** Таунхаус **/
  Townhouse = 'townhouse',
  /** Склад **/
  Warehouse = 'warehouse',
}

export enum EOfferType {
  /** коммерческая **/
  Commercial = 'commercial',
  /** квартиры **/
  Flat = 'flat',
  /** новостройки **/
  Newobject = 'newobject',
  /** загородка **/
  Suburban = 'suburban',
}

export enum EPurchaseMethod {
  /** Наличные **/
  Cash = 'cash',
  /** Материнский капитал **/
  MaternalCapital = 'maternalCapital',
  /** Ипотека **/
  Mortgage = 'mortgage',
  /** Другое **/
  Other = 'other',
}

export enum ERentType {
  /** Любой **/
  Any = 'any',
  /** Посуточно **/
  Daily = 'daily',
  /** На несколько месяцев **/
  FewMonths = 'fewMonths',
  /** От года **/
  Long = 'long',
}

export enum ERoomCount {
  /** Пятикомнатная квартира **/
  FiveRoom = 'fiveRoom',
  /** Четырехкомнатная квартира **/
  FourRoom = 'fourRoom',
  /** Многокомнатная квартира (6 и более комнат) **/
  Large = 'large',
  /** Однокомнатная квартира **/
  OneRoom = 'oneRoom',
  /** Квартира со свободной планировкой **/
  OpenPlan = 'openPlan',
  /** Студия **/
  Studio = 'studio',
  /** Трехкомнатная квартира **/
  ThreeRoom = 'threeRoom',
  /** Двухкомнатная квартира **/
  TwoRoom = 'twoRoom',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ICreateMessageResponse): TResponse200;
  400(response: ICreateMessageResponseError): TResponse400;
}
